<template>
  <div>
    <h1>Sem permissão</h1>
  </div>
</template>

<script>
export default {
  name: "SemPermissao"
};
</script>

<style lang="scss" scoped>
</style>